import React, {useEffect, useState} from 'react'
import {Box, Divider, useMediaQuery, useTheme} from '@mui/material'
import {useLocation, useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import {UpdateLogout, sessionRefreshListener} from 'services/login.service'
import {TopMenu} from './TopMenu'
import ProfileCard from './ProfileCard'
import TopHeader from './TopHeader'
import {clearLocalStorageValues} from 'shared/Logout'
import {resetLoginState} from 'features/Login/login.slice'
import {ENDPOINT} from 'config/path'
import {cpsUrl} from 'config/base'
import {resetCommonState} from 'redux/common.slice'
import {type AppDispatch} from 'redux/store'
import {get as _get} from 'lodash'

const HamMenu = () => {
    const location = useLocation()
    const theme = useTheme()
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const belowMd = useMediaQuery(theme.breakpoints.down('md'))
    const [menuOpen, setMenuOpen] = useState(false)
    const login = useSelector((state: any) => state.login)

    useEffect(() => {}, [location.pathname])

    const handleLogout = async () => {
        await sessionRefreshListener(true)
            .then((response) => {
                if (response.status === 202 || response.status === 200) {
                    const payloadLogout = {
                        newLogin: true,
                        logout: true,
                        userId: login.loginDetails.securityParams.userID
                    }
                    void UpdateLogout(payloadLogout)
                    void dispatch(resetLoginState(_get(login, 'authToken.data.refresh_token', '')))
                    dispatch(resetCommonState())
                    clearLocalStorageValues()
                    localStorage.setItem('isLoggedIn', 'false')
                    if (localStorage.getItem('NewLogin') === 'true') {
                        // window.location.href = `${cpsUrl}${ENDPOINT.basePath}${ENDPOINT.login}`
                        navigate(ENDPOINT.logout)
                    } else {
                        window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
                    }
                }
            })
            .catch((error) => {
                console.error(error)
            })
        setMenuOpen(!menuOpen)
    }

    const handleMenuIconClick = () => {
        setMenuOpen(!menuOpen)
    }

    return (
        <>
            <div className='btn-container'>
                <div className='icon-button' onClick={handleMenuIconClick}>
                    {menuOpen ? <CloseIcon className='icon' /> : <MenuIcon className='icon' />}
                </div>
            </div>
            {menuOpen && belowMd ? (
                <div className='ham-responsive-menu-container'>
                    <Divider className='hamdivider' />
                    <TopMenu setMenuOpen={setMenuOpen} />
                    <TopHeader />
                    <Divider className='hamdivider' />
                    <ProfileCard />
                    <Divider className='hamdivider' />
                    <Box
                        id='logout'
                        onClick={() => {
                            void handleLogout()
                        }}
                        sx={{
                            zIndex: theme.zIndex.modal + 1,
                            bgcolor: 'rgb(249, 252, 254)',
                            margin: '0px 40px 0px 14px',
                            '& .MuiBox-root': {
                                margin: '0px'
                            }
                        }}
                        className='hamHelpWrapper'
                    >
                        <Box
                            className='hamHelpTitle'
                            sx={{
                                zIndex: theme.zIndex.modal + 1,
                                fontWeight: '500',
                                fontSize: '16px',
                                color: '#2C2C2C',
                                px: 1,
                                alignItems: 'center',
                                justifyContent: 'center',
                                display: 'flex',
                                fontFamily: '"Roboto-Medium", "Roboto Medium", "Roboto", sans-serif',
                                textAlign: 'left',
                                lineHeight: 'normal',
                                letterSpacing: '0.6px',
                                height: '65px',
                                '&:hover': {boxSizing: 'border-box', color: '#356eab', cursor: 'pointer'},
                                width: 'auto',
                                placeContent: 'flex-start',
                                paddingLeft: '20px'
                            }}
                        >
                            <ExitToAppIcon className='menuIcons' fontSize='small' />
                            &nbsp; Logout
                        </Box>
                    </Box>
                    <Divider className='hamdivider' />
                </div>
            ) : null}
        </>
    )
}

export default HamMenu
